export default function () {
	let els = document.querySelectorAll('.collapsible');
	if ( els ) {
		els.forEach( (el) => {
			let button = el.querySelector('.collapsible__nav__toggle');
			button.onclick = () => {
				if ( el.classList.contains('is-expanded') ) {
					el.classList.remove('is-expanded');
					button.innerHTML = 'Show More';
				} else {
					el.classList.add('is-expanded');
					button.innerHTML = 'Show Less';
				}
			}
		});
	}
}
